export const transformRemittanceName = (name) => {
    const remittanceNamesObject = {
        "nhf": "NHF",
        "nsitf": "NSITF",
        "pension": "Pension",
        "paye_tax": "PAYE Tax",
    }
    return remittanceNamesObject[name?.toLowerCase()] || name;
}

export default transformRemittanceName;